goog.module('yext.location.EventLocation');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');
const Address = goog.require('yext.location.Address');
const ReferenceValue = goog.require('yext.location.ReferenceValue');
const SearchableOption = goog.require('yext.entity.fields.SearchableOption');
const TextField = goog.require('yext.textfield.TextField');

/**
 * @param {!jQuery} $ctx The field context, or a parent container
 * @constructor
 */
const EventLocation = function($ctx) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-event-location-field').addBack().filter('.js-event-location-field');
  this.$address = this.$field.find('.js-event-location-address');
  this.$timeZone = this.$field.find('.js-event-location-timezone');
  this.$referenceLocation = this.$field.find('.js-event-location-reference-location');
  this.$fieldValue = this.$field.find('.js-event-location-field-value');
  this.$edit = this.$field.find('.js-event-location-edit');

  // field is in view-only mode
  if (!this.$edit.length) {
    return;
  }

  this.$view = this.$field.find('.js-event-location-view');

  this.timestamp = this.$edit.data('timestamp');

  this.address = this.extractAddress();
  this.venueName = new TextField(this.$field.find('.js-venue-name-edit'));
  this.referenceLocation = new ReferenceValue(this.$referenceLocation);
  this.timeZone = new SearchableOption(this.$timeZone);
  this.setFieldValue();
  this.bindRadios();
  this.render();
  this.bindUpdates();
  this.bindOther();
};

/**
 * Extract the Address instance from its bound DOM
 * @return {Address}
 */
EventLocation.prototype.extractAddress = function() {
  return this.$address.find('.js-entity-address-field').data('address');
};

/**
 * Sets a hidden input to the field value, with string keys
 */
EventLocation.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * Bind the radios which allow switching between types
 */
EventLocation.prototype.bindRadios = function() {
  var self = this;

  this.subFieldSelection = this.$field.find('[name=selectEventLocationType]:checked').val();

  this.$field.find('[name=selectEventLocationType]').on('click, change', function() {
    self.subFieldSelection = self.$field.find('[name=selectEventLocationType]:checked').val();
    self.render();
    if (self.isReferenceLocationActive()) {
      self.referenceLocation.focus();
    } else if (self.isAddressActive()) {
      self.venueName.focus();
    } else if (self.isTimeZoneActive()) {
      self.timeZone.focus();
    }
  });
};

/**
 * React to sub-field update messages
 */
EventLocation.prototype.bindUpdates = function() {
  var self = this;
  $(this.address).on('updated', function() {
    self.eventAddressUpdated();
  });
  $(this.venueName).on('update.textField', function() {
    self.eventAddressUpdated();
  });
  $(this.referenceLocation).on('updated', function() {
    // If the linked location has a value and it is being edited, clear out other fields
    if (!self.referenceLocation.isEmpty() && self.isReferenceLocationActive()) {
      self.clearEventAddress();
      self.timeZone.clear();
    }
    self.onUpdate();
  });
  $(this.timeZone).on('updated', function() {
    // If the timezone has a value and it is being edited, clear out other fields
    if (!self.timeZone.isEmpty() && self.isTimeZoneActive()) {
      self.clearEventAddress();
      self.referenceLocation.clear();
    }
    self.onUpdate();
  });
};

/**
 * Other non-update bindings here
 */
EventLocation.prototype.bindOther = function() {
  var self = this;
  $(this.address).on('submitField', function() {
    self.emitSubmitField();
  });

  this.$field.find('.js-reset-event-location').click(function() {
    // Clear will empty the fields and make indeterminate false
    self.clearEventAddress();
    self.timeZone.clear();
    self.referenceLocation.clear();
    self.setSubFieldSelection();
    self.render();
  });
};

/**
 * Called when address or venue name are updated
 */
EventLocation.prototype.eventAddressUpdated = function() {
  // If the address has a value and it is being edited, clear out other fields
  if (!this.isEventAddressEmpty() && this.isAddressActive()) {
    this.timeZone.clear();
    this.referenceLocation.clear();
  }
  this.onUpdate();
};

/**
 * @return {boolean} True if both sub-fields are empty
 */
EventLocation.prototype.isEventAddressEmpty = function() {
  return this.address.isEmpty() && this.venueName.isEmpty();
};

/**
 * @return {boolean} True if both sub-fields are empty
 */
EventLocation.prototype.isEventAddressIndeterminate = function() {
  return this.address.isIndeterminate() || this.venueName.isIndeterminate();
};

/**
 * Clear the address and venue name fields
 */
EventLocation.prototype.clearEventAddress = function() {
  this.address.clear();
  this.venueName.clear();
};

/**
 * Called when any sub field is updated
 */
EventLocation.prototype.onUpdate = function() {
  this.render();
  this.setFieldValue();
  this.emitUpdate();
};

/**
 * Emit an updated message when one of the sub-fields changes
 */
EventLocation.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Emit an submit field message for when this is triggered by abnormal means.
 * Ex. The user accepting a bad address
 */
EventLocation.prototype.emitSubmitField = function() {
  $(this).trigger('submitField');
};

/**
 * Store the value of the sub-fields
 */
EventLocation.prototype.storeValue = function() {
  this.address.storeValue();
  this.venueName.saveValue();
  this.timeZone.storeValue();
  this.referenceLocation.storeValue();
};

/**
 * Reset the field to a stored state
 */
EventLocation.prototype.reset = function() {
  this.address.reset();
  this.venueName.reset();
  this.timeZone.reset();
  this.referenceLocation.reset();
  this.setSubFieldSelection();
  this.render();
};

/**
 * Set the field state to provided data
 */
EventLocation.prototype.set = function(field) {
  this.clearEventAddress();
  this.timeZone.clear();
  this.referenceLocation.clear();
  if (field['referenceLocation']) {
    this.referenceLocation.set(field['referenceLocation']);
  } else if (field['address']) {
    this.address.set(field['address']);
    this.venueName.set(field['venueName']);
  } else if (field['timeZone']) {
    this.timeZone.set(field['timeZone']);
  }
  this.timestamp = field['timestamp'];
};

/**
 * Get the display value for this field
 */
EventLocation.prototype.getDisplayValue = function() {
  if (!this.referenceLocation.isEmpty()) {
    return this.referenceLocation.model.getLabel();
  } else if (!this.isEventAddressEmpty()) {
    return this.templateAddressDisplayValue();
  } else if (!this.timeZone.isEmpty()) {
    return this.templateTimeZoneDisplayValue();
  } else {
    return helpers.emptyFieldMessage();
  }
};

/**
 * Template the address display value
 */
EventLocation.prototype.templateAddressDisplayValue = function() {
  return this.$field.find('.js-address-label-template').html()
    .replace('#LOCATION_NAME', this.venueName.model.value)
    .replace('#ADDRESS', this.address.addressLine);
};

/**
 * Template the time zone display value
 */
EventLocation.prototype.templateTimeZoneDisplayValue = function() {
  var label = this.timeZone.getDisplayValue();
  return yext.msg(
    'This event takes place in {0}',
    '<span class="time-zone-label">' + this.timeZone.getDisplayValue() + '</span>');
};

/**
 * Render the field UI, given state
 */
EventLocation.prototype.render = function() {
  var indeterminate = this.isIndeterminate();
  this.$field.find('.js-event-location-indeterminate-message').toggle(indeterminate);
  this.$field.find('.js-event-location-fields').toggle(!indeterminate);

  this.$address.toggle(this.isAddressActive());
  this.$timeZone.toggle(this.isTimeZoneActive());
  this.$referenceLocation.toggle(this.isReferenceLocationActive());

  if (this.subFieldSelection) {
    this.$field.find('[name=selectEventLocationType][value=' + this.subFieldSelection + ']').prop('checked', true);
  } else {
    this.$field.find('[name=selectEventLocationType]').prop('checked', false);
  }
};

/**
 * Render the field view mode
 */
EventLocation.prototype.renderViewMode = function() {
  this.$view.empty().html(this.getDisplayValue());
};

/**
 * Set the sub field selection based upon the model state
 */
EventLocation.prototype.setSubFieldSelection = function() {
  if (!this.referenceLocation.isEmpty()) {
    this.subFieldSelection = 'referenceLocation';
  } else if (!this.isEventAddressEmpty()) {
    this.subFieldSelection = 'address';
  } else if (!this.timeZone.isEmpty()) {
    this.subFieldSelection = 'timeZone';
  } else {
    this.subFieldSelection = undefined;
  }
};

/**
 * True if address is active
 */
EventLocation.prototype.isAddressActive = function() {
  return this.subFieldSelection === 'address';
};

/**
 * True if time zone is active
 */
EventLocation.prototype.isTimeZoneActive = function() {
  return this.subFieldSelection === 'timeZone';
};

/**
 * True if reference location is active
 */
EventLocation.prototype.isReferenceLocationActive = function() {
  return this.subFieldSelection === 'referenceLocation';
};

/**
 * @return True if all sub-fields are empty
 */
EventLocation.prototype.isEmpty = function() {
  return this.isEventAddressEmpty() && this.referenceLocation.isEmpty() && this.timeZone.isEmpty();
};

/**
 * @return True if any sub-fields are indeterminate
 */
EventLocation.prototype.isIndeterminate = function() {
  return Boolean(this.isEventAddressIndeterminate()
         || this.referenceLocation.isIndeterminate()
         || this.timeZone.isIndeterminate());
};

/**
 * @return {!Object}
 */
EventLocation.prototype.getData = function() {
  var data = {};
  if (!this.referenceLocation.isEmpty()) {
    data['referenceLocation'] = this.referenceLocation.getData();
  } else if (!this.isEventAddressEmpty()) {
    data['address'] = this.address.getData();
    data['venueName'] = this.venueName.coreData();
  } else if (!this.timeZone.isEmpty()) {
    data['timeZone'] = this.timeZone.getData();
  }
  data['timestamp'] = this.timestamp;
  return data;
};

/**
 * Trigger map marker to update itself
 */
EventLocation.prototype.updateMapMarker = function(field) {
  var message = {};
  if (field['address']) {
    var address = field['address'];
    if (address['geocodedRoutableCoordinate'] || address['geocodedDisplayCoordinate']) {
      message['geocodedRoutableCoordinate'] = address['geocodedRoutableCoordinate'];
      message['geocodedDisplayCoordinate'] = address['geocodedDisplayCoordinate'];
    }
  } else if (field['referenceLocation']) {
    var address = field['referenceLocation']['address'];
    if (address['geocodedRoutableCoordinate'] || address['geocodedDisplayCoordinate']) {
      message['geocodedRoutableCoordinate'] = address['geocodedRoutableCoordinate'];
      message['geocodedDisplayCoordinate'] = address['geocodedDisplayCoordinate'];
    }
    message['viewOnly'] = true;
  } else if (field['timeZone']) {
    message['viewOnly'] = true;
    message['hasNoLocation'] = true;
  }
  this.triggerMapMarkerUpdate(message);
};

/**
 * Send a message for the map marker field
 * @param {!Object} message
 */
EventLocation.prototype.triggerMapMarkerUpdate = function(message) {
  $('.js-map-marker').trigger('eventLocationUpdated', message);
};

exports = EventLocation;
